import { Component, OnInit, Input } from '@angular/core';
import { RouteService } from '@services/route.service';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'gob-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() newsletter: boolean=true;

  constructor(public route: RouteService, private tracking: TrackingService) { }

  ngOnInit(): void {
  }

  // Google Ads
  onContactClick(event: Event): void {
    event.preventDefault();
    this.tracking.trackContact();
  }

}
